import { USER_MANAGEMENT as FEATURE_PREFIX } from 'featurePrefix.ids'

const ACTIONS_PREFIX = 'actions'
const FILTERS_PREFIX = 'filters'
const UPSERT_MODAL_PREFIX = 'upsert-modal'
const STATUS_MODAL_PREFIX = 'status-modal'
const BULK_ACTIONS_PREFIX = 'bulk-actions'
const RESEND_INVITE_MODAL_PREFIX = 'resend-invite-modal'
const BILLING_CONTACTS_PREFIX = 'billing-contacts'

export const HeaderIds = {
  OrganizationMenu: `${FEATURE_PREFIX}__${ACTIONS_PREFIX}__organization-menu`,
  AccountHierarchyOption: `${FEATURE_PREFIX}__${ACTIONS_PREFIX}__account-hierarchy-option`,
  ManageRegionsOption: `${FEATURE_PREFIX}__${ACTIONS_PREFIX}__manage-regions-option`,
  ReassignConnectionsOption: `${FEATURE_PREFIX}__${ACTIONS_PREFIX}__reassign-connections-option`,
} as const

export const BillingContactsIds = {
  Container: `${FEATURE_PREFIX}__${BILLING_CONTACTS_PREFIX}__container`,
  ContactName: `${FEATURE_PREFIX}__${BILLING_CONTACTS_PREFIX}__contact-name`,
  AdditionalContactsCount: `${FEATURE_PREFIX}__${BILLING_CONTACTS_PREFIX}__additional-contacts-count`,
  AddContactButton: `${FEATURE_PREFIX}__${BILLING_CONTACTS_PREFIX}__add-contact-button`,
  EditContactsButton: `${FEATURE_PREFIX}__${BILLING_CONTACTS_PREFIX}__edit-contacts-button`,
} as const

export const ActionsIds = {
  ExportTable: `${FEATURE_PREFIX}__${ACTIONS_PREFIX}__export-table`,
  AddNewUser: `${FEATURE_PREFIX}__${ACTIONS_PREFIX}__add-new-user`,
} as const

export const FiltersIds = {
  SearchInput: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__search-input`,
  FilterIcon: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__filter-icon`,
  ClearFiltersButton: `${FEATURE_PREFIX}__${ACTIONS_PREFIX}__clear-filters`,
  ClearIndividualFilter: `${FEATURE_PREFIX}__${ACTIONS_PREFIX}__clear-individual-filter`,
  FilterOption: `${FEATURE_PREFIX}__${ACTIONS_PREFIX}__filter-option`,
  AnyTimeOption: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__any-time-option`,
  Last30DaysOption: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__last-30-days-option`,
  Last60DaysOption: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__last-60-days-option`,
  Last90DaysOption: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__last-90-days-option`,
  Last180DaysOption: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__last-180-days-option`,
  NeverLoggedInOption: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__never-logged-in-option`,
} as const

export const TableIds = {
  EditUserIcon: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__edit-user-icon`,
  FilterIcon: `${FEATURE_PREFIX}__${FILTERS_PREFIX}__filter-icon`,
} as const

export const UpsertModalIds = {
  UserEmailInput: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__user-email-input`,
  UserTypeDropdown: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__user-type-dropdown`,
  SalesRepNameInput: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__sales-rep-name-input`,
  SalesRepCodeInput: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__sales-rep-code-input`,
  CCCodeOption: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__cc-code-option`,
  CCEmailsInput: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__cc-emails-input`,
  AddUserButton: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__add-user-button`,
  EditUserButton: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__edit-user-button`,
  CancelEditButton: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__cancel-button`,
  ContinueButton: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__continue-button`,
  AdminUserTypeOption: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__admin-user-type`,
  UserTypeOption: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__user-type`,
  InternalUserTypeOption: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__internal-user-type`,
  NoAccessUserTypeOption: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__no-access-user-type`,
  ActiveStatusOption: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__active-status`,
  DisabledStatusOption: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__disabled-status`,
  SetPermissionsButton: `${FEATURE_PREFIX}__${UPSERT_MODAL_PREFIX}__set-permissions-status`,
} as const

export const StatusModalIds = {
  ActivateUserButton: `${FEATURE_PREFIX}__${STATUS_MODAL_PREFIX}__activate-user-button`,
  DeactivateUserButton: `${FEATURE_PREFIX}__${STATUS_MODAL_PREFIX}__deactivate-user-button`,
  BulkActivateUserButton: `${FEATURE_PREFIX}__${STATUS_MODAL_PREFIX}__bulk-activate-user-button`,
  BulkDeactivateUserButton: `${FEATURE_PREFIX}__${STATUS_MODAL_PREFIX}__bulk-deactivate-user-button`,
  ReassignRedirectButton: `${FEATURE_PREFIX}__${STATUS_MODAL_PREFIX}__reassign-redirect-button`,
  OrderListRedirectButton: `${FEATURE_PREFIX}__${STATUS_MODAL_PREFIX}__order-list-redirect-button`,
  CancelButton: `${FEATURE_PREFIX}__${STATUS_MODAL_PREFIX}__cancel-button`,
} as const

export const BulkActionsIds = {
  BulkActivateButton: `${FEATURE_PREFIX}__${BULK_ACTIONS_PREFIX}__bulk-activate-button`,
  BulkDeactivateButton: `${FEATURE_PREFIX}__${BULK_ACTIONS_PREFIX}__bulk-deactivate-button`,
  ChangeUserTypeDropdown: `${FEATURE_PREFIX}__${BULK_ACTIONS_PREFIX}__change-user-type-dropdown`,
  AddOrderEmailsButton: `${FEATURE_PREFIX}__${BULK_ACTIONS_PREFIX}__add-order-emails-button`,
  CopyPermissionsButton: `${FEATURE_PREFIX}__${BULK_ACTIONS_PREFIX}__copy-permissions-button`,
} as const

export const ResendInviteModalIds = {
  ResendInviteConfirmButton: `${FEATURE_PREFIX}__${RESEND_INVITE_MODAL_PREFIX}__resend-invite-confirm-button`,
} as const
